import styled from 'styled-components';

export const StatsRow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.75rem;
    flex-wrap: wrap;
`;

export const TotalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.5rem 1rem;
    background: transparent;
    border-radius: 8px;
    min-width: 100px;
    flex: 1;
    max-width: 150px;
    height: 70px;
`;

export const TotalLabel = styled.span`
    font-size: 0.75rem;
    color: #9ca3af;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
`;

export const TotalText = styled.span`
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 1.5rem;
    color: #e2e8f0;
    font-weight: 700;
`;

export const PredictionCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.5rem 1rem;
    background: ${({ gradient }) => gradient};
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    min-width: 100px;
    flex: 1;
    max-width: 150px;
    height: 70px;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%);
        pointer-events: none;
    }
`;

export const PredictionLabel = styled.span`
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.85);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    position: relative;
    z-index: 1;
`;

export const PredictionBadge = styled.span`
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 1.25rem;
    color: white;
    font-weight: 700;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    position: relative;
    z-index: 1;
`;

export const ProgressBarContainer = styled.div`
    width: 100%;
    margin-bottom: 1rem;
    position: relative;
`;

export const SectionLabel = styled.div`
    font-size: 0.7rem;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.5rem;
    text-align: center;
`;

export const ProgressLabels = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
`;

export const ProgressLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 0.4rem;
`;

export const LabelText = styled.span`
    font-size: 0.7rem;
    font-weight: 700;
    color: #cbd5e1;
    text-transform: uppercase;
    letter-spacing: 0.3px;
`;

export const LabelValue = styled.span`
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 0.95rem;
    font-weight: 700;
    color: ${({ color }) => color || '#6b7280'};
`;

export const LabelPercentage = styled.span`
    font-size: 0.7rem;
    font-weight: 600;
    color: #94a3b8;
`;

export const ProgressBar = styled.div`
    width: 100%;
    height: 20px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
    position: relative;
    display: flex;
`;

export const ProgressFill = styled.div`
    height: 100%;
    flex: ${({ percentage }) => percentage};
    background: ${({ isHigher }) => (isHigher ? 'linear-gradient(90deg, #22c55e 0%, #16a34a 100%)' : 'linear-gradient(90deg, #dc2626 0%, #ef4444 100%)')};
    transition:
        flex 0.3s ease,
        background 0.3s ease;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
    }
`;

export const LineMovementContainer = styled.div`
    width: 100%;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px;
    padding: 0.75rem 1rem;
    margin-bottom: 0.75rem;
`;

export const LineMovementTitle = styled.div`
    font-size: 0.7rem;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: center;
    margin-bottom: 0.6rem;
`;

export const LineMovementRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
`;

export const LineMovementValue = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.15rem;
    flex: 1;
`;

export const LineMovementNumber = styled.span`
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: ${({ large }) => (large ? '1.5rem' : '1.2rem')};
    font-weight: 700;
    color: ${({ large }) => (large ? '#60a5fa' : '#94a3b8')};
    line-height: 1;
`;

export const LineMovementLabel = styled.span`
    font-size: 0.65rem;
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.4px;
`;

export const LineMovementArrow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.2rem;
    flex: 1.2;
`;

export const DeltaBadge = styled.span`
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 0.85rem;
    font-weight: 700;
    color: ${({ positive, negative }) => (positive ? '#22c55e' : negative ? '#ef4444' : '#6b7280')};
    background: ${({ positive, negative }) => (positive ? 'rgba(34,197,94,0.1)' : negative ? 'rgba(239,68,68,0.1)' : 'rgba(107,114,128,0.1)')};
    border-radius: 20px;
    padding: 0.2rem 0.6rem;
    line-height: 1;
`;

export const MovementIcon = styled.span`
    font-size: 1rem;
    color: ${({ positive, negative }) => (positive ? '#22c55e' : negative ? '#ef4444' : '#9ca3af')};
`;

export const RankHint = styled.div`
    margin-top: 0.5rem;
    font-size: 0.7rem;
    font-style: italic;
    color: #94a3b8;
    text-align: center;
`;
